import md from "mobile-detect";
import UAParser from "ua-parser-js";

const instance = new md(window.navigator.userAgent);

class MobileDetect {
  static is(identifierString) {
    return instance.is(identifierString);
  }

  static version(identifierString) {
    return instance.version(identifierString);
  }

  static tablet() {
    return instance.tablet();
  }

  static mobile() {
    return instance.mobile();
  }

  static phone() {
    return instance.phone();
  }

  static oculus() {
    const parser = new UAParser();
    const parserResults = parser.getResult(instance.ua);
    return parserResults.browser.name === "Oculus Browser";
  }

  static desktopSafari() {
    const parser = new UAParser();
    const { browser } = parser.getResult();
    return browser.name === "Safari";
  }

  static mobileSafari() {
    const ua = navigator.userAgent;
    const parser = new UAParser(ua);
    const { browser, os, engine } = parser.getResult();

    const isKnownMobileSafari =
      browser.name === "Mobile Safari" || browser.name === "Safari";

    const isIOS = os?.name === "iOS" || /iPhone|iPad|iPod/i.test(ua);
    const isWebKit = engine?.name === "WebKit";

    // exclude Chrome, Firefox, Edge, Opera, DuckDuckGo, Aloha on iOS
    const notOtherIOSBrowser =
      !/CriOS|FxiOS|EdgiOS|OPiOS|DuckDuckGo|Aloha/i.test(ua);

    return isIOS && isWebKit && isKnownMobileSafari && notOtherIOSBrowser;
  }  

  static userAgent() {
    return instance.userAgent();
  }

  static userAgents() {
    return instance.userAgents();
  }

  static os() {
    return instance.os();
  }
}

export default MobileDetect;
